// utils/platformUtil.ts

type OS = "Windows" | "macOS" | "iOS" | "Android" | "Linux" | "ChromeOS" | "Unknown";

// userAgentData 타입 정의
interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: {
    platform: string;
  };
}

export function getOS(): OS {
  if (typeof navigator === "undefined") return "Unknown";

  const { userAgent, maxTouchPoints } = navigator;
  const ua = userAgent.toLowerCase();
  const plt = (
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform ||
    (ua.includes("win")
      ? "Windows"
      : ua.includes("mac")
      ? "macOS"
      : ua.includes("linux")
      ? "Linux"
      : ua.includes("android")
      ? "Android"
      : ua.includes("iphone") || ua.includes("ipad")
      ? "iOS"
      : ua.includes("cros")
      ? "ChromeOS"
      : "")
  ).toLowerCase();

  // iOS: iPhone, iPad (iPadOS는 macIntel이지만 touchPoint로 구분)
  const isIOS = /iphone|ipad|ipod/.test(ua) || (plt === "macintel" && maxTouchPoints > 1);

  if (isIOS) return "iOS";
  if (/android/.test(ua)) return "Android";
  if (/win/.test(plt)) return "Windows";
  if (/mac/.test(plt)) return "macOS";
  if (/linux/.test(plt)) return "Linux";
  if (/cros/.test(ua)) return "ChromeOS";

  return "Unknown";
}

// 단축 boolean 함수들
export const isWindows = () => getOS() === "Windows";
export const isMacOS = () => getOS() === "macOS";
export const isIOS = () => getOS() === "iOS";
export const isAndroid = () => getOS() === "Android";
export const isLinux = () => getOS() === "Linux";
export const isChromeOS = () => getOS() === "ChromeOS";
export const isMobile = () => isIOS() || isAndroid();
